var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplayRowActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/display-row-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.9333333,5 C21.5224371,5 22,5.44771525 22,6 C22,6.55228475 21.5224371,7 20.9333333,7 L7.06666667,7 C6.47756293,7 6,6.55228475 6,6 C6,5.44771525 6.47756293,5 7.06666667,5 L20.9333333,5 Z M20.9333333,11 C21.5224371,11 22,11.4477153 22,12 C22,12.5522847 21.5224371,13 20.9333333,13 L7.06666667,13 C6.47756293,13 6,12.5522847 6,12 C6,11.4477153 6.47756293,11 7.06666667,11 L20.9333333,11 Z M20.9333333,17 C21.5224371,17 22,17.4477153 22,18 C22,18.5522847 21.5224371,19 20.9333333,19 L7.06666667,19 C6.47756293,19 6,18.5522847 6,18 C6,17.4477153 6.47756293,17 7.06666667,17 L20.9333333,17 Z M3.25621891,4.75 C3.94314024,4.75 4.5,5.30964406 4.5,6 C4.5,6.69035594 3.94314024,7.25 3.25621891,7.25 C2.55685976,7.25 2,6.69035594 2,6 C2,5.30964406 2.55685976,4.75 3.24378109,4.75 L3.25621891,4.75 Z M3.25621891,10.75 C3.94314024,10.75 4.5,11.3096441 4.5,12 C4.5,12.6903559 3.94314024,13.25 3.25621891,13.25 C2.55685976,13.25 2,12.6903559 2,12 C2,11.3096441 2.55685976,10.75 3.24378109,10.75 L3.25621891,10.75 Z M3.25621891,16.75 C3.94314024,16.75 4.5,17.3096441 4.5,18 C4.5,18.6903559 3.94314024,19.25 3.25621891,19.25 C2.55685976,19.25 2,18.6903559 2,18 C2,17.3096441 2.55685976,16.75 3.24378109,16.75 L3.25621891,16.75 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/display-row-active",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayRowActive);
export default __webpack_public_path__ + "static/media/display-row-active.9eaf8de144c6eb15a764fe55e3403013.svg";
export { ForwardRef as ReactComponent };